/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

/**
 * Decide if communication preferences are visible for the user.
 */
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

const BaseGroupingRule = require('./base'); // If only the language, not the region, is specified, then all regions
// will be considered a match. For instance, 'de' will match 'de', 'de-de',
// 'de-at', etc. #2217


const AVAILABLE_LANGUAGES = ['de', 'en', 'es', 'fr', 'hu', 'id', 'pl', 'ru']; // If the region is specified, other regions will not match. For instance,
// 'pt-br' will not match 'pt' or 'pt-pt'. #2217

const AVAILABLE_REGIONS = ['pt-br', 'zh-tw'];
const AVAILABLE_LANGUAGES_REGEX = generateRegex(AVAILABLE_LANGUAGES, AVAILABLE_REGIONS);

function generateRegex(langs, regions) {
  const combined = langs.map(x => `${x}|${x}-[a-z]{2}`).concat(regions);
  return arrayToRegex(combined);
}

function normalizeLanguage(lang) {
  return lang.toLowerCase().replace(/_/g, '-');
}

function areCommunicationPrefsAvailable(lang, availableLanguages) {
  const normalizedLanguage = normalizeLanguage(lang);
  return availableLanguages.test(normalizedLanguage);
}

function arrayToRegex(array) {
  return new RegExp(`^(?:${array.join('|')})$`);
}

module.exports = /*#__PURE__*/function (_BaseGroupingRule) {
  _inherits(CommunicationPrefsGroupingRule, _BaseGroupingRule);

  var _super = _createSuper(CommunicationPrefsGroupingRule);

  function CommunicationPrefsGroupingRule() {
    var _this;

    _classCallCheck(this, CommunicationPrefsGroupingRule);

    _this = _super.call(this);
    _this.name = 'communicationPrefsVisible';
    return _this;
  }

  _createClass(CommunicationPrefsGroupingRule, [{
    key: "choose",
    value: function choose() {
      let subject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const featureFlags = subject.featureFlags,
            lang = subject.lang;
      let availableLanguages = AVAILABLE_LANGUAGES_REGEX;

      if (featureFlags && Array.isArray(featureFlags.communicationPrefLanguages)) {
        availableLanguages = arrayToRegex(featureFlags.communicationPrefLanguages);
      }

      if (!lang) {
        return false;
      }

      return areCommunicationPrefsAvailable(lang, availableLanguages);
    }
  }]);

  return CommunicationPrefsGroupingRule;
}(BaseGroupingRule);